import React, { useContext, useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';

import useMousePosition from '../../hooks/useMousePosition';
import { CursorContext } from '../../contexts/CursorContext';
import { isTouchDevice } from '../../helpers/isTouchDevice';

const CursorWrapper = styled.div`
  .ring {
    position: fixed;
    top: 0;
    left: 0;
    width: 22px;
    height: 22px;
    border: 2px solid ${(props) => props.theme.mainBrandColor} !important;
    border-radius: 100%;
    transform: translate(-50%, -50%);
    transition-duration: 100ms;
    transition-timing-function: ease-out;
    will-change: width, height, transform, border;
    z-index: 999;
    pointer-events: none;
  }

  .dot {
    position: fixed;
    top: 50%;
    left: 50%;
    width: 8px;
    height: 8px;
    background-color: ${(props) => props.theme.mainBrandColor};
    border-radius: 100%;
    transform: translate(-50%, -50%);
    z-index: 999;
    pointer-events: none;
  }

  .ring.hovered {
    width: 50px;
    height: 50px;
    border-width: 3px;
    border-color: ${(props) => props.theme.mainBrandColor};
  }

  .dot.hovered {
    display: none;
  }
`;

const Cursor = () => {
  const { clientX, clientY } = useMousePosition();
  const { cursor, setCursor } = useContext(CursorContext);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleMouseEnter = () => setVisible(true);
    const handleMouseLeave = () => setVisible(false);
    document.body.addEventListener('mouseenter', handleMouseEnter);
    document.body.addEventListener('mouseleave', handleMouseLeave);

    return () => {
      document.body.removeEventListener('mouseenter', handleMouseEnter);
      document.body.removeEventListener('mouseleave', handleMouseLeave);
    };
  });

  if (typeof window !== 'undefined') {
    useEffect(() => {
      setCursor({ active: false, label: null });
    }, [window.location.href]);
  }

  if (isTouchDevice()) return null;

  const cursorScale = cursor.label ? 0.85 : 0.35;

  return (
    <>
      <Helmet>
        <style type="text/css">{`
          *, *:after, *:before {
            cursor: none !important;
          }

          .show-cursor {
            cursor: auto !important;
          }
        `}</style>
      </Helmet>

      <CursorWrapper>
        <div
          style={{
            left: `${clientX}px`,
            top: `${clientY}px`,
            opacity: visible && clientX > 1 ? 0.85 : 0,
          }}
          className={`ring ${cursorScale}`}
        />
        <div
          className={`dot ${cursorScale}`}
          style={{ left: `${clientX}px`, top: `${clientY}px` }}
        />
      </CursorWrapper>
    </>
  );
};

export default Cursor;
